import { menuModalTpl } from './modal';

export { menuModalTpl }